import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m32 14.07 4.89 8.56.81 1.43 1.58.44 10.43 2.92-6.79 5.83-1.75 1.5.43 2.25 1.79 9.66-9.72-4.44-1.66-.76-1.66.76-9.72 4.44L22.42 37l.42-2.26-1.75-1.5-6.79-5.83 10.43-2.91 1.58-.44.81-1.43L32 14.07ZM32 6l-8.36 14.64L6 25.57l12.47 10.71-3.19 17.22L32 45.86l16.72 7.64-3.19-17.22L58 25.58l-17.64-4.93L32 6Z"
      }
    )
  }
);
export {
  t as Star
};
